import React from "react";
import { Fragment } from "react";

export default function ShoppingSubHeader() {
  return (
    <Fragment>
      <div className="row customers shoppingHeader insideAdd">
        <div>
          <h2>Add Part/Chemical/Others</h2>
        </div>
      </div>
    </Fragment>
  );
}
